export const selectFeedback = (s: any) => s.feedback
